import { useTitle } from "#/utils/useTitle"

export default function Layout({ children }: { children?: React.ReactNode }) {
  useTitle('Capstone')
  return <div className="relative w-full h-full overflow-hidden bg-black">{children}</div>
}
